




















































































































































































































































































































































































































































































































































































































































































































































































































































import CompanySheet from "@/components/company/CompanySheet.vue";
import DamageLocatorCombined from "@/components/damagelocator/DamageLocatorCombined.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { ReportRoleEnum } from "@/lib/enum/ReportRole.enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import { TripTypeEnum } from "@/lib/enum/trip-type.enum";
import { detailedDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { Accident, IAccident } from "@/models/accident.entity";
import { Damage, IDamage } from "@/models/damage.entity";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { IReferences, References } from "@/models/references.entity";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { IWitness, Witness } from "@/models/witness.entity";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import { DamageTypeEnum } from "@/store/enum/damage-type.enum";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { ThirdPartySystemModule } from "@/store/modules/third-party-system.store";
import { saveAs } from "file-saver";
import JsZip, { JSZipGeneratorOptions } from "jszip";
import { TranslateResult } from "vue-i18n";
import { Component, Vue } from "vue-property-decorator";
import AddressForm from "../../AddressForm.vue";
import AccidentForm from "./accident/accident-form.vue";
import WitnessForm from "./accident/witness-form.vue";
import DamageForm from "./damage/DamageForm.vue";
import ReferencesForm from "./damage/ReferencesForm.vue";
import PartnerReportMapAddress from "./PartnerReportMapAddress.vue";
import PartnerReportTowingCard from "./towing/PartnerReportTowingCard.vue";
import { ApplicationInsightsEventEnum } from "@/lib/enum/application-insights-event.enum";
import { isMobile } from "@/lib/utility/isMobile";
import ReportRequestInformationDialog from "../../ReportAttachmentRequestDialog.vue";

enum ImageUploadEnum {
  DROP = "drop",
  REVIEW = "review"
}

type ImageUpload = {
  /**
   * Used for indicating a THG request has been processed, on true `result` should be filled.
   */
  isUploaded: boolean;

  /**
   * Used for loading animation, when THG request is being processed
   */
  isLoading: boolean;

  /**
   * The file dropped and being processed
   */
  file: File;

  type?: ReportImageType | null;

  /**
   * Internal image url for display purposes
   */
  imageUrl?: string | ArrayBuffer | null;

  /**
   * Already uploaded images of the request
   */
  imageUploaded?: IImageUploaded;

  /**
   * Error state
   */
  isError?: boolean;

  /**
   * The error message
   */
  error?: Error;
};

@Component({
  components: {
    DamageLocatorCombined,
    PartnerReportMapAddress,
    MIconButton,
    MNoContent,
    MTextField,
    MSelect,
    ConfirmActionDialog,
    DropAreaMulti,
    AddressForm,
    DamageForm,
    AccidentForm,
    ReferencesForm,
    CompanySheet,
    WitnessForm,
    PartnerReportTowingCard,
    ReportRequestInformationDialog
  },
  filters: { detailedDate }
})
export default class PartnerReportDetailDamage extends Vue {
  pendingRemoveImageIds: string[] = [];

  ImageUploadEnum = ImageUploadEnum;
  ReportImageType = ReportImageType;
  ReportRoleEnum = ReportRoleEnum;
  TotalLossType = TotalLossType;

  isLoading = false;
  isDownloadImage = false;

  readonly = true;

  isDrag = false;
  isDrop = false;
  isFailed = false;
  isImageUploadDialogOpen = false;
  isImageUploadLoading = false;
  files: File[] = [];
  images: ImageUpload[] = [];
  imagePreview: string | ArrayBuffer | null | undefined = null;
  isShowImagePreviewDialog = false;

  window = ImageUploadEnum.DROP;

  isAccidentDialogOpen = false;
  isAccidentLoading = false;
  isAccidentValid = false;
  accident: IAccident | null = new Accident(this.report);

  isWitnessDialogOpen = false;
  isWitnessLoading = false;
  isWitnessValid = false;
  witness: IWitness | null = new Witness();
  editWitnessIndex: number | undefined = undefined;

  damage: IDamage | null = new Damage(this.report);
  isEditDamageDialogOpen = false;
  isDamageValid = false;
  isDamageLoading = false;
  damageKey = 0;

  references: IReferences | null = new References(this.report);
  isReferencesDialogOpen = false;
  isReferencesValid = false;
  isReferencesLoading = false;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get thirdPartySystems() {
    return ThirdPartySystemModule.filteredAndSorted;
  }

  get tripTypeItems() {
    return Object.values(TripTypeEnum).map(value => ({
      value,
      text: this.$t(`enums.TripTypeEnum.${value}`)
    }));
  }

  get damageTypeItems() {
    return (this.partner.settings?.damageTypes ?? Object.values(DamageTypeEnum)).map(value => ({
      value,
      text: this.$t(`enums.DamageTypeEnum.${value}`)
    }));
  }

  get coverageTypeItems() {
    return Object.values(CoverageTypeEnum).map(value => ({
      value,
      text: this.$t(`enums.CoverageTypeEnum.${value}`)
    }));
  }

  get persons() {
    return this.report.witness;
  }

  get mapToImage() {
    return this.report.attachment.map(i => {
      return {
        src: i.url,
        thumbnail: i.url,
        w: 0, // image.metaData?.width,
        h: 0, // image.metaData?.height,
        title: this.$t(`timeLine.PartnerReportDetailImageTimeLineElement.imageTypes.${i.type}`).toString()
      };
    });
  }

  get prependIcon() {
    if (!this.isDrag) {
      return "mdi-paperclip";
    }

    if (this.isDrag && !this.isDrop) {
      return "mdi-file-upload";
    }

    if (this.isFailed) {
      return "mdi-close";
    }

    return "mdi-check";
  }

  get isMobile() {
    return isMobile();
  }

  startEditAccident() {
    this.isAccidentDialogOpen = true;
    this.accident = new Accident(this.report);
  }

  startWitness(index: number | undefined) {
    this.witness = new Witness();
    if (index !== undefined && this.report.witness && this.report.witness[index]) {
      this.editWitnessIndex = index;
      this.witness = new Witness(this.report.witness[index]);
    }

    this.$log.debug(index, this.witness);
    this.isWitnessDialogOpen = true;
  }

  async removeWitness(index: number) {
    if (!this.report.witness) {
      throw new Error("No witness");
    }

    const newWitness = [...this.report.witness];
    const deleted = newWitness.splice(index, 1);

    if (!deleted) {
      throw new Error("No witness deleted");
    }

    try {
      this.isWitnessLoading = true;

      await this.report.updatePartial({ witness: newWitness?.map(w => w.dto) });

      this.$toast.success("🗑️");
    } catch (error) {
      handleError(error);
    } finally {
      this.isWitnessLoading = false;
    }
  }

  startDrag() {
    this.isDrag = true;
  }

  endDrag() {
    this.isDrag = false;
  }

  async addWitness() {
    if (!this.witness) {
      return;
    }

    let witness = this.report.witness;

    if (this.editWitnessIndex !== undefined) {
      if (!witness) {
        throw new Error("Can't update empty");
      }

      witness.splice(this.editWitnessIndex, 1, this.witness);
    } else {
      if (!witness) {
        witness = [this.witness];
      } else {
        witness.push(this.witness);
      }
    }

    try {
      this.isWitnessLoading = true;

      await this.report.updatePartial({ witness: witness.map(w => w.dto) });

      this.editWitnessIndex = undefined;
      this.isWitnessDialogOpen = false;
      this.witness = null;
    } catch (error) {
      handleError(error);
    } finally {
      this.isWitnessLoading = false;
    }
  }

  async updateAccident() {
    try {
      this.isAccidentLoading = true;

      if (!this.accident) {
        return;
      }

      await this.report.updatePartial({
        isUnderInfluence: this.accident.isUnderInfluence,
        tripType: this.accident.tripType,
        isValidDriversLicense: this.accident.isValidDriversLicense,
        accidentDetails: this.accident.details?.dto
      });

      this.isAccidentDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isAccidentLoading = false;
    }
  }

  async updateDamage() {
    if (!this.damage) {
      return;
    }

    try {
      this.isDamageLoading = true;

      // Remove images marked for removal
      if (this.pendingRemoveImageIds.length > 0) {
        const newAttachments = this.report.attachment.filter(
          img => !this.pendingRemoveImageIds.includes(img.id as string)
        );
        await this.report.updateReportImages({
          imageIds: newAttachments.map(img => img.id).filter(id => !!id) as string[]
        });
        this.pendingRemoveImageIds = [];
      }

      await this.report.updatePartial(this.damage.dto);

      this.damageKey++;

      this.isEditDamageDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isDamageLoading = false;
    }
  }

  markImageForRemoval(id: string) {
    if (!this.pendingRemoveImageIds.includes(id)) {
      this.pendingRemoveImageIds.push(id);
    }
  }

  undoRemoveImage(id: string) {
    this.pendingRemoveImageIds = this.pendingRemoveImageIds.filter(imgId => imgId !== id);
  }

  async updateReferences() {
    if (!this.references) {
      return;
    }

    try {
      this.isReferencesLoading = true;

      await this.report.updatePartial(this.references.dto);

      this.isReferencesDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isReferencesLoading = false;
    }
  }

  async addImages() {
    try {
      this.isImageUploadLoading = true;

      ReportModule.setPartnerName(PartnerModule.partner.companyUsername);

      for (const image of this.images.filter(i => !i.isUploaded)) {
        image.isError = false;
        image.error = undefined;
        image.isLoading = true;
        await ReportModule.addImage({
          file: image.file,
          type: image.type ?? ReportImageType.damage
        })
          .then(r => {
            image.imageUploaded = r;
            image.isUploaded = true;
          })
          .catch(e => {
            image.isError = true;
            image.error = e;
          })
          .finally(() => (image.isLoading = false));
      }

      const allImages = [
        ...this.images.map(i => i.imageUploaded?.uploadId),
        ...this.report.attachment.map(image => image.id)
      ];
      this.report.updateReportImages({ imageIds: allImages.filter((i): i is string => i !== undefined) });

      const errored = this.images.find(i => i.isError);

      if (!errored) {
        this.closeImageUploadDialog();
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.isImageUploadLoading = false;
    }
  }

  get rightText(): TranslateResult {
    switch (this.window) {
      case ImageUploadEnum.REVIEW:
        return this.$t("blueprint.create.uploadImages", { count: this.images.length });
      default:
        return this.$t("next");
    }
  }

  async next() {
    switch (this.window) {
      case ImageUploadEnum.DROP:
        this.window = ImageUploadEnum.REVIEW;
        break;

      case ImageUploadEnum.REVIEW:
        await this.addImages();

        this.$emit("imported");
        break;

      default:
        this.window = ImageUploadEnum.DROP;
        break;
    }
  }

  async prepareImageUpload() {
    for (const file of this.files) {
      const thg: ImageUpload = {
        file: file,
        isUploaded: false,
        isLoading: false,
        type: ReportImageType.damage
      };

      const reader = new FileReader();
      reader.onload = () => {
        thg.imageUrl = reader.result;
      };
      reader.readAsDataURL(file);

      this.images.push(thg);
    }
  }

  async onFileDrop(event: DragEvent) {
    const fileList: FileList | undefined = event.dataTransfer?.files;

    if (!fileList) {
      this.isDrag = false;
      this.isFailed = true;
      return;
    }

    const files = Array.from(fileList);

    files.forEach(f => {
      if (!(f.type.indexOf("image/") >= 0)) {
        this.$toast.error(this.$t("sign.ReportDocumentSignRequestForm.fileType"));
        this.isFailed = true;
        this.isDrag = false;

        throw new Error("Only images allowed");
      }
    });

    this.files = files;
    this.prepareImageUpload();

    this.isDrop = true;

    setTimeout(() => {
      this.isDrag = false;
      this.isDrop = false;
      this.isFailed = false;
      this.window = ImageUploadEnum.REVIEW;
      this.isImageUploadDialogOpen = true;
    }, 500);
  }

  popImage(index: number) {
    const popped = this.images.splice(index, 1);
    const poppedFile = this.files.splice(index, 1);
    this.$log.debug("pop", popped, poppedFile);
  }

  showImagePreview(image: ImageUpload) {
    this.isShowImagePreviewDialog = true;
    this.imagePreview = image.imageUrl;
  }

  closeImagePreview() {
    this.isShowImagePreviewDialog = false;
    this.imagePreview = null;
  }

  closeImageUploadDialog() {
    this.window = ImageUploadEnum.DROP;
    this.files = [];
    this.images = [];
    this.isImageUploadDialogOpen = false;
  }

  svgClicked(e: any) {
    if (!e) return;

    if (!this.damage) return;

    const newDamage = e.title;

    if (!this.damage.area) {
      this.damage.area = [newDamage];
    }

    const index = this.damage.area?.findIndex(v => v === newDamage) ?? -1;
    if (index > -1) {
      this.damage.area?.splice(index, 1);
    } else {
      this.damage.area?.push(newDamage);
    }

    this.damageKey++;
  }

  thumbs(up: boolean) {
    this.$appInsights.trackEvent(
      { name: ApplicationInsightsEventEnum.VOTE_AI_RESULT },
      { partnerId: this.report.partnerId, value: up, reportId: this.report.id, context: "report.summary" }
    );

    this.$emit("thumbs", up);
  }

  async startDownload() {
    this.isDownloadImage = true;
    try {
      const images = [];
      for (const file of this.report.attachment) {
        const resp = await fetch(file.url).then(resp => resp);
        if (resp.status >= 300) {
          this.$log.error("Could not download image " + file.name);
          continue;
        }
        images.push({ name: file.name, data: await resp.blob() });
      }

      const zip = JsZip();

      for (const file of images) {
        zip.file(file.name, file.data);
      }
      const options: JSZipGeneratorOptions<"blob"> = {
        type: "blob"
      };

      const zipBlob = await zip.generateAsync(options);
      const currentDate = new Date().toISOString();

      const fileName = `${this.report.claimNumber}-${currentDate}.zip`;

      return saveAs(zipBlob, fileName);
    } catch (error) {
      handleError(error);
    } finally {
      this.isDownloadImage = false;
    }
  }
}
